var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickCancel.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialogRoot",
          staticClass: "dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
            tabindex: "-1",
          },
        },
        [
          _c("div", { staticClass: "dialog__body" }, [
            _c(
              "p",
              { staticClass: "dialog__lead", attrs: { id: _vm.titleId } },
              [
                _vm._v(
                  _vm._s(_vm.$t("proofreadingIncompleteThemeDialog.message"))
                ),
              ]
            ),
            _c("p", { staticClass: "dialog__lead" }, [
              _vm._v(
                _vm._s(_vm.$t("proofreadingIncompleteThemeDialog.detail"))
              ),
            ]),
          ]),
          _c("footer", { staticClass: "dialog__footer" }, [
            _c(
              "button",
              {
                staticClass: "dialog__ok-button",
                attrs: { type: "button" },
                on: { click: _vm.onClickOk },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("proofreadingIncompleteThemeDialog.ok")) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "dialog__theme-button",
                attrs: { type: "button" },
                on: { click: _vm.onClickEditTheme },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("proofreadingIncompleteThemeDialog.editTheme")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "dialog__cancel-button",
                attrs: { type: "button" },
                on: { click: _vm.onClickCancel },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("proofreadingIncompleteThemeDialog.cancel")) +
                    " "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }